<template>
  <div class="w-full p-6">
    <!-- Breadcrumb Navigation -->
    <BreadcrumbNavigation
      :activeView="combinedActiveView"
      @navigate="handleNavigation"
    />
    <h1 class="text-2xl font-bold mb-2">
      {{ combinedActiveView === '' ? 'Administration' : viewTitles[combinedActiveView] }}
    </h1>
    <p class="text-muted-foreground mb-6">{{ combinedActiveView === '' ? 'Manage system settings, user roles, and monitor system activity' : viewSubtitles[combinedActiveView] }}</p>
    
    <!-- Main Administration Dashboard -->
    <AdminDashboard
      v-if="combinedActiveView === ''"
      @navigate="handleNavigation"
    />
    
    <!-- Email Template Management View -->
    <EmailTemplateManagement
      v-if="combinedActiveView === 'email-templates'"
      @navigate="handleNavigation"
    />
    
    <!-- User Role Management View -->
    <UserRoleManagement
      v-if="combinedActiveView === 'user-roles'"
      @navigate="handleNavigation"
    />
    
    <!-- System Configuration View -->
    <SystemConfiguration
      v-if="combinedActiveView === 'system-config'"
      @navigate="handleNavigation"
    />
    
    <!-- Audit Logs View -->
    <AuditLogs
      v-if="combinedActiveView === 'audit-logs'"
      @navigate="handleNavigation"
    />
    
    <!-- Manage Knowledgebase View -->
    <ManageKnowledgebase
      v-if="combinedActiveView === 'manage-knowledgebase'"
      @navigate="handleNavigation"
    />
    
    <!-- Due Date Management View -->
    <DueDateManagement
      v-if="combinedActiveView === 'due-dates'"
      @navigate="handleNavigation"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue';
import BreadcrumbNavigation from '@/components/admin/BreadcrumbNavigation.vue';
import AdminDashboard from '@/components/admin/AdminDashboard.vue';
import EmailTemplateManagement from '@/components/admin/EmailTemplateManagement.vue';
import UserRoleManagement from '@/components/admin/UserRoleManagement.vue';
import SystemConfiguration from '@/components/admin/SystemConfiguration.vue';
import AuditLogs from '@/components/admin/AuditLogs.vue';
import ManageKnowledgebase from '@/components/admin/ManageKnowledgebase.vue';
import DueDateManagement from '@/components/admin/DueDateManagement.vue';

export default defineComponent({
  name: 'AdministrationView',
  components: {
    BreadcrumbNavigation,
    AdminDashboard,
    EmailTemplateManagement,
    UserRoleManagement,
    SystemConfiguration,
    AuditLogs,
    ManageKnowledgebase,
    DueDateManagement
  },
  props: {
    initialView: {
      type: String,
      default: ''
    }
  },
  setup(props) {

    // Define titles for each view
    const viewTitles = {
      'email-templates': 'Email Template Management',
      'user-roles': 'User Role Management',
      'system-config': 'System Configuration',
      'audit-logs': 'Audit Logs',
      'manage-knowledgebase': 'Knowledgebase Advisori',
      'due-dates': 'Due Date Management'
    };
    
    // Define subtitles for each view
    const viewSubtitles = {
      'email-templates': 'Create and manage email templates for automated communications',
      'user-roles': 'Assign and manage user roles and permissions',
      'system-config': 'Configure system-wide settings and parameters',
      'audit-logs': 'View system activity and user action logs',
      'manage-knowledgebase': 'Manage the knowledge database for Advisori',
      'due-dates': 'Configure due dates for different actions and document types'
    };
    
    // Create a local ref to track navigation within the component
    const localView = ref('');
    
    // Combine the local view with the initialView prop
    const combinedActiveView = computed(() => {
      return localView.value || props.initialView || '';
    });
    
    function handleNavigation(view: string) {
      localView.value = view;
    }
    
    return {
      combinedActiveView,
      viewTitles,
      viewSubtitles,
      handleNavigation
    };
  }
});
</script>
